import { catchError } from 'rxjs/operators';
import { inject } from '@angular/core';
import { throwError, Observable } from 'rxjs';
import { ApplicationService } from '../../../core/application.service';
import { ResolveFn } from '@angular/router';
import { ShowSnackbarError } from '../../../core/state';
import { Store } from '@ngxs/store';

export const ApplicationSettingsResolver: ResolveFn<string[]> = (_route, _state): Observable<string[]> | Promise<string[]> | string[] => {
  const applicationService = inject(ApplicationService);
  const store = inject(Store);

  return applicationService.getLanguageGroups().pipe(
    catchError(err => {
      store.dispatch(new ShowSnackbarError('could not fetch language groups', { value: err?.message }));
      return throwError(() => err);
    })
  );
};
